import './App.scss';
import './scss/style.scss';

import { useEffect, useRef, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { wait } from './ulits';

import { UsersList } from './components/UsersList';
import { NotFound } from './components/NotFound';
import { ErrorInfo } from './components/ErrorInfo';
import { UserDetails, EditUser, AddNewUser } from './components/UserDetails';

function App() {
  const [snackbar, setSnackbar] = useState({
    visible: false,
    type: 'success',
    msg: 'Updated Successfully',
  });

  const sendSnackbar = async (type, msg) => {
    setSnackbar({
      visible: true,
      type,
      msg,
    });
    await wait(2000);
    setSnackbar({
      visible: false,
      type,
      msg,
    });
  };

  return (
    <div className="App">
      <h1>User Coords App</h1>
      <Router>
        <Routes>
          <Route index element={<Navigate to="/users" />} />
          <Route path="/users" element={<UsersList snackbar={snackbar} />} />
          <Route path="users/:id" element={<UserDetails />} />
          <Route
            path="users/:id/edit"
            element={
              <EditUser snackbar={snackbar} sendSnackbar={sendSnackbar} />
            }
          />
          <Route
            path="users/addNew"
            element={
              <AddNewUser snackbar={snackbar} sendSnackbar={sendSnackbar} />
            }
          />
          <Route path="error" element={<ErrorInfo />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
